import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60e02c59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "z-search" }
const _hoisted_2 = { class: "z-search__wrap" }
const _hoisted_3 = { class: "z-search__type" }
const _hoisted_4 = { class: "workPlaceArea" }
const _hoisted_5 = { class: "z-search__title" }
const _hoisted_6 = {
  key: 0,
  class: "recruitmentArea"
}
const _hoisted_7 = { class: "z-search__title" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("应届生")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("实习")
const _hoisted_10 = { class: "positionArea" }
const _hoisted_11 = { class: "z-search__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_caret_bottom = _resolveComponent("caret-bottom")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_icon, {
              size: 12,
              color: "#c0c4cc",
              class: _normalizeClass({
                hide: _ctx.workHide,
                display: !_ctx.workHide
              }),
              onClick: _cache[0] || (_cache[0] = () => _ctx.handleHide('workPlace'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_caret_bottom)
              ]),
              _: 1
            }, 8, ["class"]),
            _createElementVNode("span", {
              class: "workPlace",
              onClick: _cache[1] || (_cache[1] = () => _ctx.handleHide('workPlace'))
            }, "工作地点"),
            (_ctx.workPlaceIds && _ctx.workPlaceIds.length > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  style: {"float":"right","font-size":"12px"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleEmpty('workPlace')))
                }, " 清空 "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass({
              treeArea: true,
              treeHide: _ctx.workHide,
              treeDisplay: !_ctx.workHide
            })
          }, [
            _createVNode(_component_el_tree, {
              data: _ctx.workPlaceArr,
              "show-checkbox": "",
              "node-key": "code",
              ref: "workTreeRef",
              props: _ctx.defaultProps,
              "default-expand-all": false,
              onCheck: _cache[3] || (_cache[3] = (curValue, valueObj) => _ctx.handleCheck(curValue, valueObj, 'workPlace'))
            }, {
              default: _withCtx(({ node }) => [
                _createElementVNode("span", null, _toDisplayString(node.label), 1)
              ]),
              _: 1
            }, 8, ["data", "props"])
          ], 2)
        ]),
        (_ctx.recruitType == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_icon, {
                  size: 12,
                  color: "#c0c4cc",
                  class: _normalizeClass({
                hide: _ctx.schoolObjectHide,
                display: !_ctx.schoolObjectHide
              }),
                  onClick: _cache[4] || (_cache[4] = () => _ctx.handleHide('schoolObject'))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_caret_bottom)
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createElementVNode("span", {
                  class: "workPlace",
                  onClick: _cache[5] || (_cache[5] = () => _ctx.handleHide('schoolObject'))
                }, "招聘对象"),
                (_ctx.schoolObject && _ctx.schoolObject.length > 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      style: {"float":"right","font-size":"12px"},
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleEmpty('schoolObject')))
                    }, " 清空 "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass({
              treeArea: true,
              treeHide: _ctx.schoolObjectHide,
              treeDisplay: !_ctx.schoolObjectHide
            })
              }, [
                _createVNode(_component_el_checkbox_group, {
                  class: "z-search__checkbox",
                  modelValue: _ctx.schoolObject,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.schoolObject) = $event)),
                  onChange: _ctx.handleSchoolObjectChange
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_checkbox, { label: "1" }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_checkbox, { label: "2" }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_icon, {
              size: 12,
              color: "#c0c4cc",
              class: _normalizeClass({
                hide: _ctx.positionHide,
                display: !_ctx.positionHide
              }),
              onClick: _cache[8] || (_cache[8] = () => _ctx.handleHide('position'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_caret_bottom)
              ]),
              _: 1
            }, 8, ["class"]),
            _createElementVNode("span", {
              class: "position",
              onClick: _cache[9] || (_cache[9] = () => _ctx.handleHide('position'))
            }, "职位类别"),
            (_ctx.positionTypeIds && _ctx.positionTypeIds.length > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  style: {"float":"right","font-size":"12px"},
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleEmpty('position')))
                }, " 清空 "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass({
              treeArea: true,
              treeHide: _ctx.positionHide,
              treeDisplay: !_ctx.positionHide
            })
          }, [
            _createVNode(_component_el_tree, {
              data: _ctx.typeList,
              ref: "positionRef",
              "show-checkbox": "",
              "node-key": "key",
              "default-expand-all": true,
              props: _ctx.positionProps,
              onCheck: _cache[11] || (_cache[11] = (curValue, valueObj) => _ctx.handleCheck(curValue, valueObj, 'position'))
            }, {
              default: _withCtx(({ node }) => [
                _createElementVNode("span", null, _toDisplayString(node.label), 1)
              ]),
              _: 1
            }, 8, ["data", "props"])
          ], 2)
        ])
      ])
    ])
  ]))
}